<!-- src/app/app.component.html -->

<router-outlet></router-outlet>